export default {
    getUrlKey (name) {
        return decodeURIComponent(
                (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },
    formatDate(date){
        if (date == null || date ==''){
            return '';
        }
        if (!(date instanceof Date)){
            return date;
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return [year, month, day].map(this.formatNumber).join('-')
    },
    formatDateTime(date){
        if (date == null || date ==''){
            return '';
        }
        if (!(date instanceof Date)){
            return date;
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        let d = [year, month, day].map(this.formatNumber).join('-');
        let t = [hour, minute, second].map(this.formatNumber).join(':');
        return d + ' ' + t;
    },
    formatMonth(date){
        if (date == null || date ==''){
            return '';
        }
        if (!(date instanceof Date)){
            return date;
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        return [year, month].map(this.formatNumber).join('-')
    },
    formatNumber(n){
        n = n.toString();
        return n[1] ? n : '0' + n
    }
}
Number.prototype.toFixed = function (s) {
    var that = this;

    if(this < 0){
        that = -that;
    }

    let val = (parseInt(that * Math.pow( 10, s ) + 0.5) / Math.pow( 10, s )).toString()

    let index = val.indexOf(".")

    if(index < 0 && s > 0){
        val = val+"."
        for(var i = 0; i < s; i++){
            val = val + "0"
        }
    } else {
        index = val.length - index;
        for(var i = 0; i < (s - index) + 1; i++){
            val = val + "0"
        }
    }
    if(this < 0){
        return -val;
    }else {
        return val;
    }
}